import AxiosInstance from "../../utils/AxiosInstance";
import { MyProfileDetailInterface } from "./models/MyProfileDetailInterface";

const API_ROUTE = "myprofiles";

export const updateMyProfile = async (data: MyProfileDetailInterface) => {
  return await AxiosInstance.post(`/${API_ROUTE}`, data);
};
